import { render, staticRenderFns } from "./ReviewLog.vue?vue&type=template&id=6b5ea5b0&scoped=true"
import script from "./ReviewLog.vue?vue&type=script&lang=js"
export * from "./ReviewLog.vue?vue&type=script&lang=js"
import style0 from "./ReviewLog.vue?vue&type=style&index=0&id=6b5ea5b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5ea5b0",
  null
  
)

export default component.exports